import {
    CdkDragDrop,
    CdkDropList,
    moveItemInArray,
} from "@angular/cdk/drag-drop";
import { CommonModule } from "@angular/common";
import { Component, computed, inject, model, signal } from "@angular/core";
import { rxResource } from "@angular/core/rxjs-interop";
import { InfoService } from "@malirang/api-client";
import { ProductType } from "@malirang/common";
import {
    ModalAdapter,
    ModalContainer,
    ModalHeader,
} from "@malirang/front-share";
import { StoreMenuItemComponent } from "./store-menu-item/store-menu-item.component";

@Component({
    selector: "app-store-menu",
    templateUrl: "./store-menu.modal.html",
    styleUrls: ["./store-menu.modal.css"],
    imports: [
        CommonModule,
        ModalContainer,
        ModalHeader,
        StoreMenuItemComponent,
        CdkDropList,
    ],
})
export class StoreMenuModal extends ModalAdapter {
    readonly service = inject(InfoService);

    type = computed(() => this.props()?.type);

    $menus = rxResource({
        stream: () => this.service.infoControllerGetStoreMenuV1({}),
    });

    menus = computed(() =>
        this.$menus.hasValue() ? this.$menus.value() : null,
    );
    menuArray = computed(() => {
        if (!this.$menus.hasValue()) {
            return [];
        }

        const allMenus = this.$menus.value();
        const typeKeys = Object.keys(ProductType) as Array<
            keyof typeof ProductType
        >;
        return typeKeys
            .map((key) => allMenus[key])
            .filter((menu) => menu !== undefined);
    });

    isCreate = signal(false);
    category = model<string>("");

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(
            this.menuArray() || [],
            event.previousIndex,
            event.currentIndex,
        );

        this.confirmOrder();
    }

    confirmOrder() {
        this.service
            .infoControllerUpdateStoreMenuV1({
                body: {
                    디지털자료: {
                        name:
                            this.menuArray().find(
                                (m) => m.type === "디지털자료",
                            )?.name || "",
                        order: this.menuArray().findIndex(
                            (m) => m.type === "디지털자료",
                        ),
                        type: "디지털자료",
                    },
                    교구: {
                        name:
                            this.menuArray().find((m) => m.type === "교구")
                                ?.name || "",
                        order: this.menuArray().findIndex(
                            (m) => m.type === "교구",
                        ),
                        type: "교구",
                    },
                    교재: {
                        name:
                            this.menuArray().find((m) => m.type === "교재")
                                ?.name || "",
                        order: this.menuArray().findIndex(
                            (m) => m.type === "교재",
                        ),
                        type: "교재",
                    },
                },
            })
            .subscribe({
                next: () => {
                    this.toastService.success("적용되었습니다.");
                },
                error: (err) => {
                    this.toastService.error(err.message);
                },
            });
    }

    handleReload() {
        setTimeout(() => {
            this.$menus.reload();
        }, 300);
    }
}
